import { render, staticRenderFns } from "./DimishedValueCalculator.vue?vue&type=template&id=6b8b22d4&"
import script from "./DimishedValueCalculator.vue?vue&type=script&lang=js&"
export * from "./DimishedValueCalculator.vue?vue&type=script&lang=js&"
import style0 from "./DimishedValueCalculator.vue?vue&type=style&index=0&id=6b8b22d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports